import { useQuery } from '@tanstack/react-query';

import { BrandApi } from '@/api/domains/brands.api';
import { BrandQueryKeys } from '@/api/domains/brands.query-keys';

// ----------------------------------------------------------------------

export const useBrands = (params?: Record<string, unknown>) => {
  const { isLoading, isFetching, data } = useQuery({
    queryKey: BrandQueryKeys.brands(params),
    queryFn: () => BrandApi.fetchBrands(params),
    staleTime: Infinity,
  });

  return { isLoading, isFetching, brands: data?.items || [] };
};
